import axios from "axios";
import { BASEURL } from "../../baseUrl";
import { toast } from "react-toastify";

export const GET_PLANS = 'GET_PLANS';
export const ADD_PLAN = 'ADD_PLAN';
export const UPDATE_PLAN = 'UPDATE_PLAN';
export const DELETE_PLAN = 'DELETE_PLAN';

const getPlansAction = (payload) => ({ type: GET_PLANS, payload: payload });
const addPlanAction = (payload) => ({ type: ADD_PLAN, payload: payload });
const updatePlanAction = (payload) => ({ type: UPDATE_PLAN, payload: payload });
const deletePlanAction = (payload) => ({ type: DELETE_PLAN, payload: payload });

export const getPlans = (payload) => {
    return async (dispatch) => {
        try {
            const queryParams = new URLSearchParams({
                page: payload?.page || 1,
                limit: payload?.limit || 10,
                search: payload?.search || ''
            });

            await axios.get(`${BASEURL}/subscription/getAllPlans?${queryParams}`)
                .then((res) => {
                    dispatch(getPlansAction(res));
                })
                .catch((error) => {
                    console.log("Error", error);
                    dispatch(getPlansAction(error?.response));
                });
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log('Error fetching plans:', error);
        }
    }
}

export const addPlan = (data, params) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.post(`${BASEURL}/subscription/addPlan`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((res) => {
                if (res?.data?.success) {
                    toast.success(res.data.message);
                }
                dispatch(addPlanAction(res));
                dispatch(getPlans(params));
            }).catch((error) => {
                toast.error(error?.response?.data?.message || 'Something went wrong');
                dispatch(addPlanAction(error?.response));
            })
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log('Error adding plan:', error);
        }
    }
}

export const updatePlan = (id, data, params) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.put(`${BASEURL}/subscription/updatePlan/${id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((res) => {
                if (res?.data?.success) {
                    toast.success(res.data.message);
                }
                dispatch(updatePlanAction(res));
                dispatch(getPlans(params));
            }).catch((error) => {
                toast.error(error?.response?.data?.message || 'Something went wrong');
                dispatch(updatePlanAction(error?.response));
            })
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log('Error updating plan:', error);
        }
    }
}

export const deletePlan = (id, params) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${BASEURL}/subscription/deletePlan/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((res) => {
                if (res?.data?.success) {
                    toast.success(res.data.message);
                }
                dispatch(deletePlanAction(res));
                dispatch(getPlans(params));
            }).catch((error) => {
                toast.error(error?.response?.data?.message || 'Something went wrong');
                dispatch(deletePlanAction(error?.response));
            })
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log('Error deleting plan:', error);
        }
    }
}